
import { Vue, Component } from "vue-property-decorator";
import VSwatches from "vue-swatches";
import Editor from "./editor";
@Component({
  components: { VSwatches },
  mixins: [Editor],
})
export default class ColorSelector extends Vue {}
